import type { AuthTokens, ExistResponse, User } from '../types'
import { apiFetch } from './client'
export { registerRenewHandler, type ApiResult } from './client'

export async function checkExist(email: string) {
  return apiFetch<ExistResponse>('/api/auth/exist', {
    method: 'POST',
    body: JSON.stringify({ email }),
  })
}

export async function resendCode(email: string, turnstileToken: string) {
  return apiFetch<{ sent: boolean; cooldownSeconds: number }>('/api/auth/code', {
    method: 'POST',
    body: JSON.stringify({ email, turnstileToken }),
  })
}

export async function register(params: {
  email: string
  otp: string
  password: string
  name?: string
}) {
  return apiFetch<AuthTokens>('/api/auth/register', {
    method: 'POST',
    body: JSON.stringify(params),
  })
}

export async function login(email: string, password: string) {
  return apiFetch<AuthTokens>('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  })
}

export async function getMe(token: string) {
  return apiFetch<User>('/api/auth/me', {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  })
}

export async function renewToken() {
  return apiFetch<{ token: string }>('/api/auth/renew', { method: 'POST' })
}

export async function logoutApi(): Promise<void> {
  await apiFetch('/api/auth/logout', { method: 'POST' })
}

/** Step 1: request a reset OTP for the given email */
export async function forgotPasswordSendCode(email: string, turnstileToken: string) {
  return apiFetch<{ sent: boolean }>('/api/auth/forgot-password', {
    method: 'POST',
    body: JSON.stringify({ email, turnstileToken }),
  })
}

/** Step 2: verify OTP and set a new password; returns an access token on success */
export async function forgotPasswordReset(params: {
  email: string
  otp: string
  newPassword: string
}) {
  return apiFetch<AuthTokens>('/api/auth/forgot-password', {
    method: 'POST',
    body: JSON.stringify(params),
  })
}

export async function requestSetupPasswordEmail(email: string, turnstileToken: string, returnTo?: string) {
  return apiFetch<{ sent: boolean }>('/api/auth/setup-password/request', {
    method: 'POST',
    body: JSON.stringify({ email, turnstileToken, returnTo }),
  })
}

export async function consumeSetupPassword(params: {
  token: string
  newPassword: string
}) {
  return apiFetch<AuthTokens>('/api/auth/setup-password/consume', {
    method: 'POST',
    body: JSON.stringify(params),
  })
}
